import useTranslation from '../../hooks/useTranslation';
import FieldRow from '../FieldRow';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { COUNTY_FALLBACK, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ApplicationDetailsSection: FunctionComponent<Props> = ({ application, testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.applicationDetailsSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>{translations.APPLICATION_DETAILS}</Wrapper>

            <FieldRow label={translations.DATE} value={application.date} />

            <FieldRow label={translations.STATE} value={application.state} />

            <FieldRow label={translations.COUNTY} value={application.county ?? COUNTY_FALLBACK} />

            <FieldRow label={translations.FIELD_NAME} value={application.fieldName} />

            <FieldRow label={translations.CROP} value={application.crop} />

            <FieldRow label={translations.TARGET_PEST} value={application.targetPest} />

            <FieldRow label={translations.TOTAL_ACRES} value={`${application.totalAcres}`} />

            <FieldRow
                label={translations.APPLICATION_METHOD}
                value={application.applicationMethod}
            />
        </VerticalContainer>
    );
};

export default ApplicationDetailsSection;
